import React, { Component } from 'react';
import { Col, Row, DropdownButton, Dropdown } from "react-bootstrap";
import { Button } from "../common";
import './preferenceView.scss';
import { get, post } from './../../utility/apiClient';
import Select from 'react-select';
import { GtagEvent } from './../../utility/googleAnalytics';
import MessageBox from '../../components/common/messageBox/MessageBox';
import GoogleMapsView from '../../components/googleMaps/GoogleMapsView';
import ExternalFooter from '../../components/footer/ExternalFooter';

/**-- Imports for redux --*/
import { connect } from 'react-redux';
import { EncryptCommon } from '../../utility/security';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { addUserDetail } from '../../redux/actions/userDetailsActions';
import { addPreference } from '../../redux/actions/preferenceActions';
import PickupDark from '../../assets/img/icons/pickup-dark.svg';
import PickupLight from '../../assets/img/icons/pickup-light.png';
import { showMessageBox, resetMessageBox } from '../../redux/actions/messageBoxActions';
import { resetUserRedirect } from '../../redux/actions/userRedirectActions';
import { updateIsTemporaryCart, updateAddress } from '../../redux/actions/userDetailsActions';
import CustomGoogleMap from '../../pages/GeoLocation/CustomGoogleMap';
import storeResetFunction from '../../redux/storeResetFunction';
import { addLatLongForLoyalty } from '../../redux/actions/V2_0/latLongForLoyalty';


// map the redux states to props
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        loadingScreenVisible: state.loadingScreen,
        userData: state.userDetails,
        selectedEssentialPackagesList: state.selectedEssentialPackages,
        systemConfigurationData: state.systemConfiguration,
        userRedirect: state.userRedirect
    }
};

// map the redux actions to props
const mapDispatchToProps = {
    showLoadingScreen,
    hideLoadingScreen,
    addUserDetail,
    addPreference,
    showMessageBox,
    resetMessageBox,
    resetUserRedirect,
    updateIsTemporaryCart,
    updateAddress,
    addLatLongForLoyalty
};

class PreferenceView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeView: 1,
            cityID: null,
            city: '',
            suburbID: null,
            suburb: '',
            outletID: null,
            selectedOutlet: null,
            searchSuburbID: null,
            errorMessage: "",
            cityList: [],
            suburbList: [],
            outletList: [],
            searchSuburbList: [],
            originalOutletList: [],
            filteredSuburbList: [],
            isSuburbBoxDisabled: true,
            is2ndTimeDeliveryShopper: false,
            is2ndTimePickUpShopper: false,
            isDisabledShopNowBtn: false,
            isQuotaFullMessage: false,

            suburbKey: 0,
            searchSuburbKey: 0,
            cityKey: 0,
            outletKey: 0,

            selectedSuburb: null,
            selectedCity: null,
            isVisible: false,

            //shipping details
            listShippingDetails: [],
            shippingDetailsList: [],
            addressTypesList: [],
            addressTypeName: "",
            shippingDetailsID: 0,
            shippingDetailsIDKey: 0,
            selectedShippingDetails: null,
            addressTypeID: 0,
            fullName: "",
            fullNameError: "",

            lat: 6.923263,
            lon: 79.856426,
            customerSelectedGeocoding: {},
            refreshMap: 0,

            AddressLine1: "",
            AddressLine1Error: "",
            AddressLine2: "",
            AddressLine2Error: "",
            suburbError: "",
            isSuburbChanged: false,
            isDefault: true,
            isNewAddress: false
        }
        // this.handleCityChange = this.handleCityChange.bind(this);
        this.handleSuburbChange = this.handleSuburbChange.bind(this);
        this.handleOutletChange = this.handleOutletChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDiliveryInfo = this.handleDiliveryInfo.bind(this);
        this.handleOutletList = this.handleOutletList.bind(this);
        this.handleShippingAddressChange = this.handleShippingAddressChange.bind(this);
        this.GetGeocodingForAddress = this.GetGeocodingForAddress.bind(this);
        this.setShippingAddress = this.setShippingAddress.bind(this);
        this.inputHandler = this.inputHandler.bind(this);
        this.addNewShippingDetails = this.addNewShippingDetails.bind(this);
        this.setCustomerSelectedGeocoding = this.setCustomerSelectedGeocoding.bind(this);
    }

    componentDidMount() {
        this.getComboData(true);
        // let messageBox = {
        //     show: true,
        //     title: "Online Order Quota",
        //     className: "info",
        //     content: "Hello,\nOnline order quotas in some of the areas under curfew have already been fulfilled. Therefore certain areas may not appear on the grid for selection. We are trying our best to ensure we serve you during these challenging times.\nTeam Keells",
        //     isConfirmation: false,
        //     callBackFunction: () => { }
        // }
        // this.props.showMessageBox(messageBox);

    };

    getShippingAddress() {
        if (this.state.activeView === 1) {
            this.props.showLoadingScreen();
            get('/MyAccount/LoadShippingDetails')//do here
                .then(response => {
                    if (response.status == 200) {
                        if (response.data.statusCode == 200) {
                            let completeShippingAddress = response.data.result.listShippingDetails.filter(elm => elm.addressLine1 !== "" && elm.addressLine2 !== "" && elm.city !== "");
                            let shippingDetailsList = completeShippingAddress.map(i => {
                                return {
                                    value: i.shippingDetailsID,
                                    label: i.addressTypeName + " | " + i.addressLine1 + ", " + i.addressLine2 + ", " + i.city
                                };
                            });
                            let suburbList = response.data.result.suburbs.map(i => {
                                return {
                                    value: i.cityId,
                                    label: i.name
                                };
                            });
                            let defaultShippingDetails = null;
                            let tempdefaultShipAddress = completeShippingAddress.find(x => x.isDefault);
                            if (tempdefaultShipAddress) {
                                defaultShippingDetails = {
                                    value: tempdefaultShipAddress.shippingDetailsID,
                                    label: tempdefaultShipAddress.addressTypeName + " | " + tempdefaultShipAddress.addressLine1 + ", " + tempdefaultShipAddress.addressLine2 + ", " + tempdefaultShipAddress.city
                                }
                            } else {
                                tempdefaultShipAddress = completeShippingAddress[0]
                                if (tempdefaultShipAddress) {
                                    defaultShippingDetails = {
                                        value: tempdefaultShipAddress.shippingDetailsID,
                                        label: tempdefaultShipAddress.addressTypeName + " | " + tempdefaultShipAddress.addressLine1 + ", " + tempdefaultShipAddress.addressLine2 + ", " + tempdefaultShipAddress.city
                                    }
                                }
                            }
                            let isCustomAddress = completeShippingAddress.length > 0 ? false : true;
                            this.setState({
                                listShippingDetails: response.data.result.listShippingDetails,
                                shippingDetailsList,
                                shippingDetailsID: defaultShippingDetails ? defaultShippingDetails.value : 0,
                                selectedShippingDetails: defaultShippingDetails ? defaultShippingDetails : [],
                                shippingDetailsIDKey: this.state.shippingDetailsIDKey + 1,
                                showHeavyLoadMessage: response.data.result.showHeavyLoadMessage,
                                isCustomAddress,
                                // suburbList: response.data.result.suburbs,
                                filteredSuburbList: suburbList,
                                suburbKey: this.state.suburbKey + 1,
                                addressTypesList: response.data.result.listAddressTypes,
                            }, () => {
                                this.props.hideLoadingScreen();
                                this.setShippingAddress();
                            })
                        } else {
                            this.props.hideLoadingScreen();
                            let messageBox = {
                                show: true,
                                title: "Oops!",
                                className: "error",
                                content: response.data.errorList[0].statusMessage,
                                isConfirmation: false
                            }
                            this.props.showMessageBox(messageBox);
                        }
                    } else {
                        this.props.hideLoadingScreen();
                    }
                })
            //Get delivery dates
            this.props.showLoadingScreen();
        }
    }

    setCustomerSelectedGeocoding(center) {
        this.setState({
            customerSelectedGeocoding: center
        })
    }

    setShippingAddress() {
        let shippingDetail = this.state.listShippingDetails.filter(a => a.shippingDetailsID === this.state.selectedShippingDetails.value);
        let selectedSuburb;
        if (shippingDetail) {

            let suburb = this.state.suburbList.find(x => x.cityId === shippingDetail[0].suburbID);
           /* selectedSuburb = {
                value: suburb !== undefined ? suburb.cityId : 0,
                label: suburb !== undefined ? suburb.name : ""
            }*/
            if(suburb){

                selectedSuburb = {
                    value: suburb.cityId,
                    label: suburb.name 
                }

            }else {

                 selectedSuburb = {
                    value:  0,
                    label: ""
                }

                this.setState({
                    AddressLine1: '',
                    AddressLine2: '',
                    City: '',
                    isAddressLine1Valid: false,
                    isAddressLine2Valid: false,
                    isCityValid: false
                })

                let messageBox = {
                    show: true,
                    title: "Error",
                    className: "error",
                    content: 'Delivery city you have selected previously is temporarily blocked. Please enter a new address to proceed further.',
                    isConfirmation: false,
                    callBackFunction: () => {}
                }
                this.props.showMessageBox(messageBox);
            }

            if (shippingDetail.length > 0 && suburb) {
                this.setState({
                    AddressLine1: shippingDetail[0].addressLine1,
                    AddressLine2: shippingDetail[0].addressLine2,
                    addressTypeID: shippingDetail[0].addressTypeID,
                    city: selectedSuburb.label,
                    isAddressLine1Valid: true,
                    isAddressLine2Valid: true,
                    isCityValid: true,
                    isUserHasGeoLocation: true,
                    lat: shippingDetail[0].latitude,
                    lon: shippingDetail[0].longitude,
                    selectedSuburb: selectedSuburb,
                    suburbID: suburb !== undefined ? suburb.cityId : null,
                    // suburbKey: this.state.suburbKey + 1
                    refreshMap: this.state.refreshMap + 1,
                    cityID: shippingDetail[0].suburbID != 0 ? suburb.cityId : null,
                    city: suburb !== undefined ? suburb.name : "",
                    addressTypeName: shippingDetail[0].addressTypeName,
                    fullName: shippingDetail[0].fullName,
                    shippingDetailsID: this.state.selectedShippingDetails.value,
                    outletID: suburb !== undefined ? suburb.branchCode : "",
                    isDefault: shippingDetail[0].isDefault,
                    isNewAddress: false
                }, () => {
                })
                let GeoLocationForLoyalty = {
                    geolocationLatitudeforLoyalty: this.state.lat,
                    geolocationLongitudeforLoyalty: this.state.lon
                }
                this.props.addLatLongForLoyalty(GeoLocationForLoyalty);
            } else {
                this.setState({
                    AddressLine1: '',
                    AddressLine2: '',
                    City: '',
                    isAddressLine1Valid: false,
                    isAddressLine2Valid: false,
                    isCityValid: false
                })
            }
        } else {
            this.setState({
                AddressLine1: '',
                AddressLine2: '',
                City: '',
                isAddressLine1Valid: false,
                isAddressLine2Valid: false,
                isCityValid: false
            })
        }
    }

    handleShippingAddressChange(e) {
        this.setState({
            shippingDetailsID: e ? e.value : null,
            selectedShippingDetails: e ? e : null,
        }, () => {
            this.setShippingAddress();
            this.hideErrorMessage();
        })
    };

    handleDiliveryInfo() {
        window.location.href = "/deliveryInfo";;
    };

    handleOutletList() {
        window.location.href = "/storeLocatorInfor";
    };

    switchView(value) {
        this.setState({
            activeView: value,
            errorMessage: "",
            cityID: null,
            suburbID: null,
            outletID: null,
            filteredSuburbList: [],
            isSuburbBoxDisabled: true,
            selectedCity: null,
            selectedOutlet: null,
            outletKey: this.state.outletKey + 1,
            cityKey: this.state.cityKey + 1,
            isDisabledShopNowBtn: false,
            isQuotaFullMessage: false
        }, () => {
            // this.handleSearchSuburb();
            this.getComboData(false);
            this.getShippingAddress();
            this.handleQuotaFullMessage();
        })
    };

    addNewShippingDetails() {
        let selectedSuburb = {
            value: 0,
            label: ""
        }
        let addressTypes = this.state.addressTypesList.filter(x => x.addressTypeID == 1)[0];

        this.setState({
            AddressLine1: "",
            AddressLine2: "",
            city: "",
            fullName: "",
            isUserHasGeoLocation: false,
            lat: 0,
            lon: 0,
            selectedSuburb: selectedSuburb,
            suburbID: null,
            suburbKey: this.state.suburbKey + 1,
            refreshMap: this.state.refreshMap + 1,
            cityID: null,
            city: "",
            selectedShippingDetails: [],
            addressTypeID: addressTypes.addressTypeID,
            addressTypeName: addressTypes.addressTypeName,
            isSuburbChanged: false,
            shippingDetailsID: 0,
        })
    }

    inputHandler(e) {
        const name = e.target.name;
        const errorField = e.target.name + "Error";
        this.setState({
            [name]: e.target.value
        })
        if (e.target.value) {
            this.setState({
                [errorField]: ""
            })
        }
    }

    handleSuburbChange(e) {
        this.setState({
            suburbID: e != null ? e.value : null,
            cityID: e != null ? e.value : null,
            selectedSuburb: e != null ? e : null,
            city: e != null ? e.label : null,
            isSuburbChanged: true,
        }, () => {
            this.handleQuotaFullMessage();
            this.validateDelivery();
            // this.getSuburbs()
        })

        if (e != null) {
            this.setState({
                suburbError: ""
            })
        }
    };

    GetGeocodingForAddress(e) {
        this.props.showLoadingScreen();
        this.handleSuburbChange(e)
        let shippingDetails = {
            AddressLine1: this.state.AddressLine1,
            AddressLine2: this.state.AddressLine2,
            City: e != null ? e.label : '',
            SuburbID: e != null ? e.value : 0
        }
        post(`/MyAccount/GetGeoCodeForAddress`, shippingDetails)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        lat: response.data.result.results[0].geometry.location.latitude,
                        lon: response.data.result.results[0].geometry.location.longitude,
                        customerSelectedGeocoding: {
                            lat: response.data.result.results[0].geometry.location.latitude,
                            lng: response.data.result.results[0].geometry.location.longitude,
                        },
                        refreshMap: this.state.refreshMap + 1
                    })
                }
                else if (response.status === 500) {
                    this.setState({ isSessionValid: false, });
                    let messageBox = {
                        show: true,
                        title: "Error while processing...",
                        className: "error",
                        content: "Please Reload the Page and try again",
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            });
    }

    handleOutletChange(e) {
        let selectedValue = e != null ? e.value : 'SCUP';
        let outlet = this.state.originalOutletList.find(x => x.outletCode == selectedValue);
        this.setState({
            outletID: e ? e.value : null,
            selectedOutlet: e,
            isDisabledShopNowBtn: e ? true : false,
            isQuotaFullMessage: e ? true : false,
            lat: outlet.latitude,
            lon: outlet.longitude,
            selectedCode: outlet.outletCode
        }, () => {
            if (this.state.outletID) {
                this.validatePickup();
                this.handleQuotaFullMessage()
            }
        })
    };

    handleQuotaFullMessage() {
        if (this.state.activeView == 1) {
            let hasSuburb = this.state.selectedSuburb != null ? this.state.selectedSuburb.value != 0 ? true : false : false;
            if (hasSuburb) {
                let suburb = this.state.suburbList.find(x => x.cityId === this.state.selectedSuburb.value);
                if (suburb.availableDeliveryDates == null) {
                    this.setState({
                        isDisabledShopNowBtn: true,
                        isQuotaFullMessage: true
                    })
                } else {
                    let suburbMaxOrdersReached = suburb.availableDeliveryDates.availableDateRange.filter(x => x.maxOrdersReached === false).length > 0 ? false : true;
                    if (suburbMaxOrdersReached && suburbMaxOrdersReached != undefined) {
                        if (suburb.branchCode === suburb.substituteOutletCode) {
                            this.setState({
                                isDisabledShopNowBtn: true,
                                isQuotaFullMessage: true
                            })
                        }
                        else {
                            this.setState({
                                isDisabledShopNowBtn: false,
                                isQuotaFullMessage: false
                            })
                        }
                    }
                    else {
                        this.setState({
                            isDisabledShopNowBtn: false,
                            isQuotaFullMessage: false
                        })
                    }
                }
            }
            else {
                this.getComboData(false);
            }
        } else {
            if (this.state.outletID != null) {
                let _outlet = this.state.originalOutletList.find(x => x.outletCode === this.state.outletID);
                let maxOrdersReached = _outlet.availablePickUpDates.availableDateRange.filter(x => x.maxOrdersReached === false).length > 0 ? false : true;
                if (maxOrdersReached && maxOrdersReached != undefined) {
                    this.setState({
                        isDisabledShopNowBtn: true,
                        isQuotaFullMessage: true
                    })
                }
                else {
                    this.setState({
                        isDisabledShopNowBtn: false,
                        isQuotaFullMessage: false
                    })
                }
            } else {
                this.setState({
                    isDisabledShopNowBtn: false,
                    isQuotaFullMessage: false
                })
            }
        }
    };

    SaveGeoLocations() {

        this.props.showLoadingScreen();
        let shippingDetails = {
            EncryptedShippingDetailsID: 0,
            FullName: this.state.fullName,
            AddressTypeID: this.state.addressTypeID,   //type 4
            AddressLine1: this.state.AddressLine1,
            AddressLine2: this.state.AddressLine2,
            City: this.state.city,
            IsDefault: this.state.isDefault,
            IsActive: true,
            Latitude: this.state.customerSelectedGeocoding.lat,
            Longitude: this.state.customerSelectedGeocoding.lng,
            EncryptedCustomerID: "",
            SuburbID: this.state.suburbID,
            ShippingDetailsID: this.state.shippingDetailsID,
        }

        //pass the selected shipping details id
        EncryptCommon(shippingDetails.EncryptedShippingDetailsID, (encryptedShippingDetailsId) => {
            shippingDetails.EncryptedShippingDetailsID = encryptedShippingDetailsId;
            post(`/MyAccount/SaveShippingDetails`, shippingDetails)
                .then(response => {

                    if (response.status === 200) {
                        if (response.data.result != null) {
                            if (response.data.result.distance.value > response.data.result.maxDeliveryRadiusViaOutlet) {
                                let messageBox = {
                                    show: true,
                                    title: "Oops!",
                                    className: "warning",
                                    content: 'This location you have selected  is not in the radius covered by the store. Distance from the store to the selected location is ' + response.data.result.distance.text + '. Please recheck the location',
                                    isConfirmation: false,
                                    callBackFunction: null
                                }
                                this.props.showMessageBox(messageBox);
                                this.props.hideLoadingScreen();
                                this.setState({
                                    suburbID: null,
                                    cityID: null,
                                    selectedSuburb: null,
                                    city: null,
                                }, () => { })
                            } else {

                                this.setState({
                                    suburbID: response.data.result.suburbID,
                                    shippingDetailsID: response.data.result.shippingDetailsID
                                }, () => { })
                                let messageBox = {
                                    show: true,
                                    title: "Success",
                                    className: "success",
                                    content: 'Successfully Update your Geo Location',
                                    isConfirmation: false,
                                    callBackFunction: () => { this.deliverySubmitHandler(); }
                                }
                                this.props.showMessageBox(messageBox);
                            }
                        } else {
                            this.setState({ isSessionValid: false, });
                            let messageBox = {
                                show: true,
                                title: "Error while processing...",
                                className: "error",
                                content: "Please retry The process",
                                isConfirmation: false,
                                callBackFunction: null
                            }
                            this.props.showMessageBox(messageBox);
                        }
                        this.props.hideLoadingScreen();
                    }
                    else if (response.status === 500) {
                        this.props.hideLoadingScreen();
                        this.setState({ isSessionValid: false, });
                        let messageBox = {
                            show: true,
                            title: "Error while processing...",
                            className: "error",
                            content: "Please retry The process",
                            isConfirmation: false,
                            callBackFunction: null
                        }
                        this.props.showMessageBox(messageBox);
                    }
                });
        });
    }

    handleSubmit() {

        if (this.state.activeView === 0) {
            this.setState({
                errorMessage: "Please select the shipping method"
            })
        }
        if (this.state.activeView === 1) {
            if (this.validateDelivery()) {

                if (this.state.isSuburbChanged) {

                    this.SaveGeoLocations();
                } else {
                    this.props.showLoadingScreen();
                    this.deliverySubmitHandler();
                }
            }
        }
        if (this.state.activeView === 2) {
            if (this.validatePickup()) {
                let outlet = this.state.originalOutletList.find(x => x.outletCode === this.state.outletID);
                if (outlet) {
                    // GtagEvent({ action: 'submit', category: 'form', label: 'Shipping method pickup' });
                    let data = {
                        outletCode: outlet.outletCode,
                        outletName: outlet.outletDescription,
                        shoppingMethod: "Pickup",
                        mainOutletCode: outlet.outletCode,
                        mainOutletDescription: outlet.outletDescription,
                        suburbID: 0,
                        availableDeliveryDates: outlet.availablePickUpDates,
                        maxOrdersReached: outlet.maxOrdersReached,
                    }
                    this.props.addPreference(data).then(() => {
                        this.props.hideLoadingScreen();
                        let userRedirect = this.props.userRedirect
                        if (userRedirect.redirectUrl) {
                            this.props.resetUserRedirect().then(() => {
                                window.location.replace(userRedirect.redirectUrl);
                            });
                        } else {
                            window.location.replace("/");
                        }
                    })
                }
            }
        }
    };

    deliverySubmitHandler() {
        let outlet = this.state.suburbList.find(x => x.cityId === this.state.suburbID);
        if (outlet) {
            // GtagEvent({ action: 'submit', category: 'form', label: 'Shipping method delivery' });
            let data = {
                outletCode: outlet.maxOrdersReached ? outlet.substituteOutletCode : outlet.branchCode,
                outletName: outlet.maxOrdersReached ? outlet.substituteOutletDescription : outlet.branchName,
                shoppingMethod: "Delivery",
                mainOutletCode: outlet.branchCode,
                mainOutletDescription: outlet.branchName,
                suburbID: this.state.suburbID,
                availableDeliveryDates: outlet.availableDeliveryDates,
                maxOrdersReached: outlet.maxOrdersReached,
            }
            this.props.addPreference(data).then(() => {
                this.props.hideLoadingScreen();
                let userRedirect = this.props.userRedirect
                if (userRedirect.redirectUrl) {
                    this.props.updateIsTemporaryCart(false);
                    this.props.resetUserRedirect().then(() => {
                        window.location.replace(userRedirect.redirectUrl);
                    });
                } else {
                    let addressBody = {
                        addressLine1: this.state.AddressLine1,
                        addressLine2: this.state.AddressLine2,
                        city: this.state.city,
                        shippingDetailsID: this.state.shippingDetailsID,
                        selectedOutlet: outlet.maxOrdersReached ? outlet.substituteOutletCode : outlet.branchCode,
                    }
                    this.props.updateAddress(addressBody);

                    window.location.replace("/");
                }

            })
        }
    }

    validatePickup() {
        if (this.state.outletID) {
            this.hideErrorMessage();
            return true;
        } else {
            this.setState({
                errorMessage: "An Outlet is required"
            })
        }
        return false;
    };

    validateDelivery() {
        let isvalide = true;
        let message = "";

        if (this.state.cityID && this.state.suburbID) {
            this.hideErrorMessage();
            isvalide = true;
        }
        if (this.state.AddressLine1 === "") {
            this.setState({
                AddressLine1Error: "House No or Lane is required"
            })
            isvalide = false;
        }
        if (this.state.AddressLine2 === "") {
            this.setState({
                AddressLine2Error: "Street Name is required"
            })
            isvalide = false;
        }
        if (this.state.fullName === "") {
            this.setState({
                fullNameError: "Name is required"
            })
            isvalide = false;
        }
        if (this.state.cityID == null || this.state.suburbID == null) {
            message = "A City is required";
            isvalide = false;
            this.setState({
                suburbError: "Suburb is required"
            })
        }
        this.setState({
            errorMessage: message
        })
        return isvalide;
    };

    hideErrorMessage() {
        this.setState({
            errorMessage: "",
            AddressLine1Error: "",
            AddressLine2Error: "",
            suburbError: "",
        })
    };

    getComboData(firstTime) {
        this.props.showLoadingScreen();
        get("/Web/GetDeliveryPreferences")
            .then(response => {
                if (response.data.statusCode == 200) {
                    let result = response.data.result;
                    let cityList = result.deliveryCityList.map(i => {
                        return {
                            value: i.cityId,
                            label: i.name
                        };
                    });
                    let suburbList = result.deliverySuburbsList;
                    let outletList = result.outletDetails.map(i => {
                        return {
                            value: i.outletCode,
                            label: i.outletDescription,
                            availablePickUpDates: i.availablePickUpDates
                        };
                    });

                    this.setState({
                        cityList: cityList,
                        suburbList: suburbList,
                        outletList: outletList,
                        originalOutletList: result.outletDetails,
                        searchSuburbID: result.lastOrderPreference.shoppingMethodID == 1 ? result.lastOrderPreference.suburbID : null,
                        activeView: firstTime ? result.lastOrderPreference.shoppingMethodID : this.state.activeView,
                        outletID: firstTime ? result.lastOrderPreference.shoppingMethodID == 2 ? result.lastOrderPreference.locationCode : null : this.state.outletID,
                        is2ndTimeDeliveryShopper: result.lastOrderPreference.shoppingMethodID == 1 ? true : false,
                        is2ndTimePickUpShopper: result.lastOrderPreference.shoppingMethodID == 2 ? true : false
                    }, () => {
                        if (this.state.searchSuburbID !== null) {
                            // this.handleSearchSuburb()
                        }

                        if (this.state.outletID !== null) {
                            let outlet = this.state.outletList.find(a => a.value === this.state.outletID);
                            this.setState({
                                selectedOutlet: outlet ? outlet : null,
                                outletID: outlet ? this.state.outletID : null,
                                is2ndTimeDeliveryShopper: false,
                                is2ndTimePickUpShopper: outlet ? true : false
                            }, () => {
                                this.handleQuotaFullMessage()
                            })
                        }
                        if (firstTime) {
                            this.getShippingAddress();
                            this.handleQuotaFullMessage();
                        }
                    })
                    this.setState({ isVisible: true });
                } else {
                    this.setState({ isVisible: true });
                    this.setState({ isVisible: true });
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: "Something went wrong. We're working on getting this fixed as soon as we can. You may be able to try again.",
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                    this.logout();
                }
                this.props.hideLoadingScreen();
            })
    };

    logout() {
        this.props.showLoadingScreen();
        post("/Login/SessionLogout").then(response => {
            //check response data exist
            if (response.status == 200) {
                storeResetFunction();
                window.location.href = "/welcome";
            }
            else this.props.hideLoadingScreen();
        })
    };

    getSuburbs() {
        if (this.state.cityID) {
            let filteredList = this.state.suburbList.filter(x => x.deliveryCityId === this.state.cityID);
            filteredList = filteredList.map(i => {
                return {
                    value: i.cityId,
                    label: i.name,
                    availableDeliveryDates: i.availableDeliveryDates
                };
            });
            this.setState({
                filteredSuburbList: filteredList,
                isSuburbBoxDisabled: false
            }, () => { this.handleQuotaFullMessage() })
        } else {
            this.setState({
                // filteredSuburbList: [],
                isSuburbBoxDisabled: true
            }, () => {
                this.handleQuotaFullMessage()
            });
        }
    };

    render() {
        const isMobile = (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ? true : false;
        return (
            <React.Fragment>
                <Row className={isMobile ? 'pt-3' : 'pt-3 pl-5 pr-5'} style={{ marginBottom: "5%" }}>
                    <Col md="4">
                        <div>
                            <div className=''>
                                <div className="form-group col">
                                    <div className='header'>
                                        <span>Select the Shipping Method</span>
                                    </div>
                                    {
                                        this.state.activeView === 1 ?
                                            <span className='description black no-margin font-weight-bold'>Select the city you want the order delivered to</span>
                                            :
                                            <span className='description black no-margin font-weight-bold'>Select from where you want to pick up your order</span>
                                    }

                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className="form-group col d-flex">
                                    <div >
                                        <span className='description black no-margin'>Delivery</span>
                                        <br></br>
                                        <button className={this.state.activeView === 1 ? "shipping-button-active" : "shipping-button"} onClick={this.switchView.bind(this, 1)}><i className="fas fa-truck fa-4x"></i></button>
                                    </div>
                                    <div>
                                        <span className='description black no-margin'>Pickup</span>
                                        <br></br>
                                        {/* <button className={this.state.activeView === 2 ? "shipping-button-active" : "shipping-button"} onClick={this.switchView.bind(this, 2)}><i className="fas fa-hands fa-4x"></i></button> */}
                                        <button className={this.state.activeView === 2 ? "shipping-button-active" : "shipping-button"} onClick={this.switchView.bind(this, 2)}><img src={this.state.activeView === 2 ? PickupLight : PickupDark} className="PickUpButtonImage" /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=''>
                            <Col>
                                <div className="form-group">
                                    <div className='header'>
                                        {
                                            this.state.activeView === 1 ?
                                                <span>Address</span>
                                                :
                                                <span>Preferred store</span>
                                        }

                                    </div>
                                </div>
                                {
                                    this.state.activeView === 1 ?
                                        <>
                                            <div className="form-group row ml-1 mb-1">
                                                <div className="custom-control custom-radio col md-6">
                                                    <input key={`rsc_exist`} name="radio_shipping" id={`radio_shipping_existing`} type="radio" className="custom-control-input "
                                                        onClick={this.switchView.bind(this, 1)}
                                                        checked={this.state.isNewAddress === false}
                                                        value={this.state.isNewAddress} />
                                                    <label htmlFor={`radio_shipping_existing`} className="custom-control-label mr-5">You saved addresses</label>
                                                </div>
                                                <div className="custom-control custom-radio col md-6">
                                                    <input key={`rsc_custom`} name="radio_shipping" id={`radio_shipping_custom`} type="radio" className="custom-control-input "
                                                        onClick={() => this.setState({ isNewAddress: true }, () => { this.addNewShippingDetails(); })}
                                                        checked={this.state.isNewAddress === true}
                                                        value={this.state.isNewAddress} />
                                                    <label htmlFor={`radio_shipping_custom`} className="custom-control-label">Enter new address</label>
                                                </div>
                                            </div>
                                            <div className="form-group mb-1">
                                                <Select options={this.state.shippingDetailsList}
                                                    key={this.state.shippingDetailsIDKey}
                                                    value={this.state.selectedShippingDetails}
                                                    placeholder="Select a Shipping Address"
                                                    isClearable={false}
                                                    onChange={this.handleShippingAddressChange}
                                                    id="ShippingAddress"
                                                    theme={theme => ({
                                                        ...theme,
                                                        borderRadius: '0px 25px',
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#B3B3B3',
                                                            primary: '#64bf47',
                                                            neutral0: 'white'
                                                        },
                                                    })}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label>Name</label>
                                                <input id="fullName" name="fullName" placeholder="Full Name" type="text" className="form-control"
                                                    value={this.state.fullName}
                                                    onChange={this.inputHandler}
                                                />
                                                <span className="error-span">{this.state.fullNameError}</span>
                                            </div>
                                            <div className="form-group mb-1">
                                                <label>Address Type</label>

                                                <div id='dropdownCustom' >
                                                    <DropdownButton title={this.state.addressTypeName} variant='' >
                                                        {
                                                            this.state.addressTypesList.map((type) => {
                                                                return (
                                                                    <Dropdown.Item as="button" onClick={() => {
                                                                        this.setState({ addressTypeID: type.addressTypeID, addressTypeName: type.addressTypeName })
                                                                    }}>
                                                                        {type.addressTypeName}
                                                                    </Dropdown.Item>)
                                                            })
                                                        }
                                                    </DropdownButton>
                                                </div>
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="AddressLine1">House No or Lane *</label>
                                                <input maxLength="100" id="AddressLine1" name="AddressLine1" placeholder="House No or Lane *" type="text" className="form-control" value={this.state.AddressLine1} onChange={this.inputHandler} />
                                                <span className="error-span">{this.state.AddressLine1Error}</span>
                                            </div>
                                            <span
                                                className={`form-text text-muted ${!this.state.isAddressLine1Valid ? '' : 'd-none'}`} >
                                                Please enter the house no or lane</span>
                                            <div className="form-group">
                                                <label htmlFor="AddressLine2">Street Name *</label>
                                                <input maxLength="100" id="AddressLine2" name="AddressLine2" placeholder="Street Name *" type="text" className="form-control" value={this.state.AddressLine2} onChange={this.inputHandler} />
                                                <span className="error-span">{this.state.AddressLine2Error}</span>
                                            </div>
                                            <span
                                                className={`form-text text-muted ${!this.state.isAddressLine2Valid ? '' : 'd-none'}`} >
                                                Please enter the street name</span>
                                            <div className="form-group mb-3">
                                                <label htmlFor="City">City *</label>
                                                <Select options={this.state.filteredSuburbList}
                                                    key={this.state.suburbKey}
                                                    value={this.state.selectedSuburb}
                                                    // isDisabled={this.state.isSuburbBoxDisabled}
                                                    placeholder="Select a Suburb"
                                                    isClearable={true}
                                                    onChange={this.GetGeocodingForAddress}
                                                    id="suburbBox"
                                                    theme={theme => ({
                                                        ...theme,
                                                        borderRadius: '0px 25px',

                                                    })}
                                                />
                                                <span className="error-span">{this.state.suburbError}</span>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className='row'>
                                                <div className="form-group col">
                                                    <Select options={this.state.outletList}
                                                        key={this.state.outletKey}
                                                        placeholder="Select a store"
                                                        isClearable={true}
                                                        value={this.state.selectedOutlet}
                                                        onChange={this.handleOutletChange}
                                                        id="outletBox"
                                                        theme={theme => ({
                                                            ...theme,
                                                            borderRadius: '0px 25px',
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: '#B3B3B3',
                                                                primary: '#64bf47',
                                                                neutral0: '#EFEFEF'
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                }

                            </Col>
                        </div>
                    </Col>
                    <Col md="8">
                        <>
                            <div className='header'>
                                {
                                    this.state.activeView === 1 ?
                                        <span>Select the city you want the order delivered to</span>
                                        :
                                        <span>The location of the selected store</span>
                                }

                            </div>
                            {/* <div className='row'>
                                <div className="form-group col d-flex">
                                    <span className={`description green ${(this.state.is2ndTimeDeliveryShopper && this.state.activeView === 1) ? '' : 'd-none'}`}><b>Hello, Welcome back. We have already selected the delivery location for you based on your last online order with us.
                                        You can change it by clicking on the drop down below.</b></span>
                                    <span className={`description green ${(this.state.is2ndTimePickUpShopper && this.state.activeView === 2) ? '' : 'd-none'}`}><b>Hello, Welcome back. We have already selected the Pickup store for you based on your last online order with us.
                                        You can change it by clicking on the drop down below.</b></span>
                                </div>
                            </div> */}
                            {this.state.activeView === 1 ?
                                <div style={{ height: "50vh", border: "solid", borderColor: "green" }}>
                                    <CustomGoogleMap
                                        key={this.state.refreshMap}
                                        lat={this.state.lat}
                                        lng={this.state.lon}
                                        isMobile={false}
                                        setCustomerSelectedGeocoding={this.setCustomerSelectedGeocoding}
                                    />
                                </div>
                                :
                                <div style={{ height: "50vh", border: "solid", borderColor: "green" }}>
                                    <GoogleMapsView
                                        lat={this.state.lat}
                                        lon={this.state.lon}
                                    />
                                </div>
                            }
                            <Row className='mt-3'>
                                <Col className='' md='8'>
                                    <span className="form-text text-muted col">{this.state.errorMessage}</span>
                                    {this.state.activeView === 1 ?
                                        <>
                                            <div>
                                                <div className="form-group col d-flex align-items-center">
                                                    <span className="form-text col warning-text"><i className="fas fa-info-circle"></i> If you have selected  a different Delivery location from the grid and entered an address in another area your order will not be fulfilled. It will be cancelled and a refund processed.
                                                        If your delivery area is not listed in our delivery grid it could be because the quota allocated for your area has been fulfilled for today or we are not delivering to your area yet. Please check our delivery grid for more. Watch our Facebook page for regular updates.
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                        : null}

                                    <div className='row'>
                                        <div className="form-group col d-flex">
                                            <span className={`form-text text-muted col ${(this.state.isQuotaFullMessage == true) ? '' : 'd-none'}`}>{this.state.activeView === 1 ? "Sorry, we have reached the maximum number of orders for the day. Please try a different delivery location" : "Sorry, we have reached the maximum number of orders for the day. Please try a different pickup store"}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col className='col align-items-left' md='4'>
                                    <Button disabled={this.state.isDisabledShopNowBtn} secondary onClick={this.handleSubmit}>Shop Now</Button>
                                    <div >
                                        {
                                            (this.state.activeView === 1) ?
                                                <Button className="btn-v1 mt-3" secondary onClick={this.handleDiliveryInfo}>Our delivery grid <i className="fa fa-play-circle ml-3" style={{ color: "#64BF47" }}></i></Button> :
                                                <Button className="btn-v1 mt-3" secondary onClick={this.handleOutletList}>Our stores list <i className="fa fa-play-circle ml-3" style={{ color: "#64BF47" }}></i></Button>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </>
                    </Col>
                </Row>
                {/* <Row style={{ marginTop: this.state.activeView === 2 ? "24rem" : "17rem" }}>
                    <ExternalFooter />
                </Row> */}

                <Row className={this.state.activeView === 1 ? 'preferenceFotterDelivery' : 'preferenceFotterPickup'}>
                    <ExternalFooter />
                </Row>
                <MessageBox />
            </React.Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferenceView);